import { Dialog, RadioGroup } from '@headlessui/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDispatch, useSelector } from 'react-redux';
import useTranslation from '../../../hooks/useTranslations';
import { selectActiveLanguage, selectSystemLanguages, setActiveLanguageId } from '../../../redux/modules/data/localizationSlice';
import { CheckmarkAlphaIcon } from '../../misc/icons/Icons';
import ModalWrapper from '../layouts/partials/ModalWrapper';

const LanguageModal = ({ isLanguageModalOpen, setIsLanguageModalOpen }) => {
	const systemLanguages = useSelector((state) => selectSystemLanguages(state));
	const activeLanguageId = useSelector((state) => selectActiveLanguage(state));

	const t = useTranslation();
	const dispatch = useDispatch();

	return (
		<ModalWrapper isModalOpen={isLanguageModalOpen} setIsModalOpen={setIsLanguageModalOpen} showCloseIcon maxWidth="max-w-sm">
			<Dialog.Title
				as="h3"
				className="text-[1.25rem] font-semibold text-oly-gray-darkest mr-7 mb-4"
			>
				{t('ifu_filter_language')}
			</Dialog.Title>
			{/* <Dialog.Description
				as="p"
				className="text-[1.0625rem] text-oly-gray-darkest mb-8 leading-6 html-content"
			/> */}
			<div className="w-full pb-6">
				<div className="w-full max-w-md mx-auto">
					<RadioGroup value={activeLanguageId} onChange={(value) => dispatch(setActiveLanguageId({ activeLanguageId: value }))}>
						<RadioGroup.Label className="sr-only">{t('ifu_filter_language')}</RadioGroup.Label>
						<div className="flex flex-wrap justify-center -m-2">
							{Object.keys(systemLanguages).map((key) => (
								<div className="w-1/2" key={key}>
									<RadioGroup.Option
										key={key}
										value={systemLanguages[key].id}
										className={({ checked }) => `${checked ? 'bg-oly-blue-default text-white ring-offset-1 ring-offset-white ring-oly-blue-default-light ring-opacity-60' : 'bg-white can-hover:hover:bg-oly-gray-lightestAlpha45 ring-oly-gray-lightest'} ring-1 m-2 relative p-3 cursor-pointer flex focus:outline-none`}
										// className={({ active, checked }) => `${active ? 'ring-2 ring-offset-2 ring-offset-white ring-oly-blue-default-light ring-opacity-60' : ''} ${checked ? 'bg-oly-blue-default text-white' : 'bg-white'} m-2 relative rounded-lg shadow-md p-3 cursor-pointer flex focus:outline-none`}
									>
										{({ checked }) => (
											<>
												<div className="flex items-center justify-between w-full">
													<div className="flex items-center mr-2">
														<RadioGroup.Description
															as="span"
															className="flex items-center"
														>
															<LazyLoadImage
																alt=""
																src={`${process.env.REACT_APP_API_BASE_URL}/images/flags/${systemLanguages[key].thumb}`}
																wrapperClassName="flex-shrink-0 w-8 mr-2"
															/>
														</RadioGroup.Description>
														<RadioGroup.Label
															as="p"
															className={`${checked ? 'text-white' : 'text-gray-900'}`}
														>
															{key}
														</RadioGroup.Label>
													</div>
													{checked && (
														<div className="flex-shrink-0 text-white">
															<CheckmarkAlphaIcon className="w-6 h-6" />
														</div>
													)}
													{!checked && (
														<div className="flex-shrink-0 w-6 h-6 text-white" />
													)}
												</div>
											</>
										)}
									</RadioGroup.Option>
								</div>
							))}
							<div className="w-1/2 h-0" />
						</div>
					</RadioGroup>
				</div>
			</div>
		</ModalWrapper>
	);
};

export default LanguageModal;
